const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function MemberAvatar({ uid, avatar, name = "", color = "", size = 26, cocon = false, ring = true }) {
  const initial = (name || "?").trim().charAt(0).toUpperCase() || "?";
  const dim = { width: size, height: size, minWidth: size };
  const showRing = ring && !cocon;
  const border = showRing ? `1.5px solid ${color || "hsl(32 90% 55% / 0.5)"}` : "none";

  const inner = avatar && uid ? (
    <img
      src={`${BACKEND_URL}/api/avatar/${uid}`}
      alt=""
      data-testid={`member-avatar-photo-${uid}`}
      className="rounded-full object-cover flex-shrink-0"
      style={{ ...dim, border }}
    />
  ) : (
    <span
      data-testid="member-avatar-initial"
      className="rounded-full flex items-center justify-center flex-shrink-0 font-semibold"
      style={{
        ...dim,
        border,
        color: color || "var(--primary)",
        background: color ? `${color}22` : "hsl(32 90% 55% / 0.14)",
        fontSize: Math.round(size * 0.42),
      }}
    >
      {initial}
    </span>
  );

  if (!cocon) return inner;

  const outer = size + 7;
  return (
    <span
      className="member-cocon-ring rounded-full flex items-center justify-center flex-shrink-0"
      style={{ width: outer, height: outer, minWidth: outer }}
      title="Membre Le Cocoon"
      data-testid="member-avatar-cocon"
    >
      <span
        className="rounded-full flex items-center justify-center"
        style={{ width: size + 3, height: size + 3, minWidth: size + 3, background: "hsl(240 20% 6%)" }}
      >
        {inner}
      </span>
    </span>
  );
}
